// extracted by mini-css-extract-plugin
module.exports = {"mainbox":"CorporateProfile_mainbox__20NMK","infobox":"CorporateProfile_infobox__1TWnT","more":"CorporateProfile_more__1T69e"};